/* eslint-disable camelcase */
import {
  addJourney,
  updateJourney,
  deleteJourney,
} from '@state/builders/journeys/helpers'
import {
  getJourneyById,
  getJourneysByIds,
} from '@state/queries/journeys/get-journeys'

export const updateJourneysOnAddLegs = (rawJourneys, parentJourneyId) => {
  addJourney({
    data: [...rawJourneys],
  }).then(({ journeys }) => {
    const ojp_response_journeys = getJourneysByIds(
      journeys.map((journey) => journey.id)
    )

    const parentJourney = getJourneyById(parentJourneyId)
    const journeyIdsToDelete = parentJourney.journey_planner_response.map(
      (journey) => journey.id
    )

    deleteJourney((journey) => journeyIdsToDelete.includes(journey.id))

    updateJourney({
      id: parentJourney.id,
      journey_planner_response: ojp_response_journeys,
    })
  })
}
